import { useMemo } from "react"
import { useSelector } from "react-redux"
import { PageRoutes } from "@/constants/routes"
import { RootState } from "@/store"
import { rolePermissions, Feature, UserRole } from "@/types/user"

export function useUserRole(feature: PageRoutes | Feature) {
   const { role, isSuperAdmin } = useSelector(
      ({ userReducer }: RootState) => userReducer
   )
   return useMemo(() => {
      const allowed =
         isSuperAdmin || rolePermissions[role as UserRole]?.includes(feature)

      return allowed
   }, [feature, role, isSuperAdmin])
}
